import { Explicacao } from '../../components/Explicacao'
import { dataHora } from '../../lib/datas'
import { TEXTOS } from '../../lib/glossario'
import type { SincronizacaoDoDiario, SituacaoDoDiario } from '../../types/repositorios'

/**
 * A situação da cópia do Diário de Bordo dentro do cartão da coleta.
 *
 * Sem o Diário ninguém é equipe interna, e o relatório passa a incluir a SEXEC sem avisar — por
 * isso "indisponível" aparece com o motivo, e não só como um traço.
 *
 * @param props a situação lida do servidor
 * @returns o bloco
 */
export function BlocoDoDiario({ diario }: { diario: SituacaoDoDiario }) {
  const t = TEXTOS.repositorios.coleta.diario

  return (
    <div className="border-t border-slate-100 pt-3" aria-label={t.titulo}>
      <h3 className="flex items-center gap-1 text-sm font-semibold text-slate-800">
        {t.titulo}
        <Explicacao termo="equipeInterna" />
      </h3>
      <p className="mt-1 text-xs text-slate-500">{t.ajuda}</p>
      <dl className="mt-2 grid gap-2 text-sm sm:grid-cols-2">
        <div>
          <dt className="text-xs font-semibold text-slate-500">{t.titulo}</dt>
          {diario.disponivel ? (
            <dd className="text-slate-800">
              {t.disponivel} · {t.pessoas(diario.pessoas)} · {t.casados(diario.autoresCasados)}
            </dd>
          ) : (
            <dd className="mt-1 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-slate-800">
              {t.indisponivel} {diario.motivoIndisponivel}
            </dd>
          )}
        </div>
        <div>
          <dt className="text-xs font-semibold text-slate-500">{t.ultima}</dt>
          <dd className="text-slate-800">
            <Leitura rodada={diario.ultimaSincronizacao} />
          </dd>
        </div>
      </dl>
    </div>
  )
}

function Leitura({ rodada }: { rodada?: SincronizacaoDoDiario }) {
  const t = TEXTOS.repositorios.coleta.diario
  if (!rodada) {
    return <>{t.nenhuma}</>
  }
  if (rodada.situacao === 'EM_ANDAMENTO') {
    return (
      <>
        {t.emAndamento} ({dataHora(rodada.iniciadaEm)})
      </>
    )
  }
  if (rodada.situacao === 'FALHOU') {
    return (
      <span className="text-red-800">
        {t.falhou} ({dataHora(rodada.concluidaEm ?? rodada.iniciadaEm)}): {rodada.erro}
      </span>
    )
  }
  return (
    <>
      {dataHora(rodada.concluidaEm)} — {t.resultado(rodada.pessoas, rodada.autoresCasados)}
    </>
  )
}
